<div class="card" [ngClass]="{ 'big' : card.big }">
    <img [src]="card.big ? card.image : 'assets/images/' + card.image">
    <div class="body">
        <div class="font-h4">{{card.title}}</div>
        <div [ngClass]="{ 'font-body2' : card.big, 'font-body3' : !card.big }">{{card.text}}</div>
        <page-link *ngIf="card.big" [link]="seeMoreLink" (click)="showModal()"></page-link>
    </div>
</div>